
import { FeaturedAdsInput, FeaturedAdsInputError } from "modules/featured_ads/state/actionType";

export const FormDataValidation = (
  data: FeaturedAdsInput
): FeaturedAdsInputError => {
  const errors: FeaturedAdsInputError = {};
  if (!data.name) {
    errors.name = "Featutred ads name is required";
  }

  if (!data.status) {
    errors.status = "Status is required";
  }
  if (!data.featured_type) {
    errors.featured_type = "Featured Ads Type is required";
  }
  if (!data.featured_order) {
    errors.featured_order = "Featured order is required";
  }

  // if (data.featured_type === FeaturedAdsEnum.image) {
  //   if (!data.imageFile) {
  //     errors.imageFile = "Image is required";
  //   }
  // }
  // if (data.featured_type === FeaturedAdsEnum.video) {
  //   if (!data.video) {
  //     errors.video = "Video is required";
  //   }
  // }

  return errors;
};
